export const TID = {
  // Login
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error-msg",
  quickLoginAdmin: "quick-login-admin",
  quickLoginBranch: "quick-login-branch",
  quickLoginAgent: "quick-login-agent",
  quickLoginStaff: "quick-login-staff",

  // Layout
  sidebar: "app-sidebar",
  logoutBtn: "logout-btn",
  navDashboard: "nav-dashboard",
  navCustomers: "nav-customers",
  navSavings: "nav-savings",
  navLoans: "nav-loans",
  navCollections: "nav-collections",
  navBranches: "nav-branches",
  navUsers: "nav-users",
  navPermissions: "nav-permissions",
  navAgentCollect: "nav-agent-collect",

  // Common
  addBtn: (r) => `add-${r}-btn`,
  editBtn: (r) => `edit-${r}-btn`,
  deleteBtn: (r) => `delete-${r}-btn`,
  saveBtn: "save-btn",
  cancelBtn: "cancel-btn",

  // Agent collect
  collectCustomerSelect: "collect-customer-select",
  collectAccountSelect: "collect-account-select",
  collectAmount: "collect-amount-input",
  collectSubmit: "collect-submit-btn",
  collectReceipt: "collect-receipt-view",
  collectNewBtn: "collect-new-btn",
};
